import { DOWNLOAD_MESSAGES } from './downloadMessages';

export type BrowserDownloadSupport = {
  supported: boolean;
  message?: string;
};

function hasRequiredApis(): boolean {
  return (
    typeof Blob !== 'undefined' &&
    typeof URL !== 'undefined' &&
    typeof URL.createObjectURL === 'function' &&
    typeof URL.revokeObjectURL === 'function' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

function hasCanvasJpegSupport(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }

  const canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = 1;

  return (
    typeof canvas.toBlob === 'function' ||
    typeof canvas.toDataURL === 'function'
  );
}

export function getBrowserDownloadSupport(): BrowserDownloadSupport {
  if (!hasRequiredApis()) {
    return {
      supported: false,
      message: DOWNLOAD_MESSAGES.BROWSER_UNSUPPORTED,
    };
  }

  if (!hasCanvasJpegSupport()) {
    return {
      supported: false,
      message: DOWNLOAD_MESSAGES.BROWSER_UNSUPPORTED,
    };
  }

  return { supported: true };
}

export function assertBrowserDownloadSupport(): void {
  const support = getBrowserDownloadSupport();

  if (!support.supported) {
    throw new Error(support.message || DOWNLOAD_MESSAGES.BROWSER_UNSUPPORTED);
  }
}
